var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"rounded-xl",attrs:{"color":"lightest","flat":""}},[_c('v-card-text',[_vm._v(" Please "),_c('a',{on:{"click":function($event){return _vm.$root.$emit('openLogin')}}},[_vm._v("log in")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }